// Mock data for Etta's Acres portfolio (frontend-only phase)

export const siteMeta = {
  brand: "Rashmi's Camera",
  tagline: "A visual mind trying to capture everything all at once.",
  location: 'Travelling the world',
  email: 'hello@rashmiscamera.com',
  socials: [
    { label: 'Instagram', href: '#' },
    { label: 'Pinterest', href: '#' },
    { label: 'YouTube', href: '#' },
  ],
};

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/#about' },
  { label: 'Projects', to: '/#projects', hasDropdown: true },
];

export const navRight = [
  { label: 'Contact', to: '/#contact' },
  { label: 'More', to: '/#more' },
];

export const heroImage =
  'https://images.unsplash.com/photo-1677040069687-285c33220631';

export const aboutImages = {
  left: '/assets/rashmi1.jpg',
  right: '/assets/rashmi2.jpg',
};

export const cowsImage =
  'https://images.unsplash.com/photo-1731273800629-8aecc8cf4aa4';

export const marqueeWords = [
  'FASHION',
  'TRAVELLING',
  'ADVISOR',
  'VISUALS',
  'LIFESTYLE',
];

export const projects = [
  {
    slug: 'foodiepages',
    title: 'Foodiepages',
    subtitle: 'A curated gifting company based in Toronto',
    year: '',
    role: '',
    cover:
      'https://www.foodiepages.ca/cdn/shop/files/220804-FoodiePages_Catalogue-Shot4_resized.jpg?v=1741441779&width=1800',
    accent: '#C97B4A',
    description: '',
    hideDetails: true,
    gallery: [
      {
        type: 'video',
        src: '/assets/foodiepages/reel.mp4',
        aspect: '9 / 16',
        poster: 'https://www.foodiepages.ca/cdn/shop/files/4to3-Cropped5.jpg?v=1669046133&width=1200',
        pair: 'https://www.foodiepages.ca/cdn/shop/files/4to3-Cropped5.jpg?v=1669046133&width=1800',
      },
      'https://www.foodiepages.ca/cdn/shop/files/4to3-Cropped1.jpg?v=1669046207&width=1800',
    ],
  },
  {
    slug: 'spinco',
    title: 'Spinco',
    subtitle: 'Studio Campaign · Motion & Grit',
    year: '',
    role: '',
    cover: '/assets/spinco/cover.jpg',
    accent: '#8B3A3A',
    description: '',
    hideDetails: true,
    reelGrid: true,
    reelCols: 3,
    gallery: [
      {
        type: 'video',
        src: '/assets/spinco/reel.mp4',
        aspect: '1280 / 2276',
        poster: '/assets/spinco/poster.jpg',
      },
      {
        type: 'video',
        src: '/assets/spinco/reel3.mp4',
        aspect: '1280 / 2276',
        poster: '/assets/spinco/poster3.jpg',
      },
      {
        type: 'video',
        src: '/assets/spinco/reel2.mp4',
        aspect: '1280 / 2276',
        poster: '/assets/spinco/poster2.jpg',
      },
    ],
  },
  {
    slug: 'lavender-farm',
    title: 'Avalon Lavender Farm',
    subtitle: 'Summer Harvest Story',
    year: '2023',
    role: 'Editorial \u00b7 Styling \u00b7 On-camera',
    cover: '/assets/avalon/lav02.jpg',
    accent: '#7A6FA3',
    description: '',
    hideDetails: true,
    gallery: [
      { type: 'video', src: '/assets/avalon/reel.mp4', poster: '/assets/avalon/lav01.jpg', pair: '/assets/avalon/lav02.jpg' },
      '/assets/avalon/lav05.jpg',
      '/assets/avalon/lav06.jpg',
      '/assets/avalon/lav01.jpg',
      '/assets/avalon/lav07.jpg',
      '/assets/avalon/lav08.jpg',
      '/assets/avalon/lav03.jpg',
      '/assets/avalon/lav09.jpg',
      '/assets/avalon/lav04.jpg',
    ],
  },
  {
    slug: 'bubbly',
    title: 'Bubbly',
    subtitle: 'Drink Lifestyle Campaign',
    year: '',
    role: '',
    cover: '/assets/bubbly/cover.jpg',
    accent: '#C9A75A',
    description: '',
    hideDetails: true,
    gallery: [
      {
        type: 'video',
        src: '/assets/bubbly/reel.mp4',
        aspect: '16 / 9',
        fullWidth: true,
        poster: '/assets/bubbly/poster.jpg',
      },
    ],
  },
  {
    slug: 'bts-loreal',
    title: 'BTS \u00b7 L\u2019Or\u00e9al',
    subtitle: 'Behind the Scenes \u00b7 Beauty Editorial',
    year: '',
    role: '',
    cover: '/assets/loreal/v01.jpg',
    accent: '#2A2A1E',
    description: '',
    hideDetails: true,
    reelGrid: true,
    reelHeading: 'BTS of shoots',
    gallery: [
      { type: 'video', src: '/assets/loreal/v01.mp4', poster: '/assets/loreal/v01.jpg', aspect: '9 / 16' },
      { type: 'video', src: '/assets/loreal/v02.mp4', poster: '/assets/loreal/v02.jpg', aspect: '9 / 16' },
      { type: 'video', src: '/assets/loreal/v03.mp4', poster: '/assets/loreal/v03.jpg', aspect: '9 / 16' },
      { type: 'video', src: '/assets/loreal/v04.mp4', poster: '/assets/loreal/v04.jpg', aspect: '9 / 16' },
      { type: 'video', src: '/assets/loreal/v05.mp4', poster: '/assets/loreal/v05.jpg', aspect: '9 / 16' },
      { type: 'video', src: '/assets/loreal/v06.mp4', poster: '/assets/loreal/v06.jpg', aspect: '9 / 16' },
      { type: 'video', src: '/assets/loreal/v07.mp4', poster: '/assets/loreal/v07.jpg', aspect: '9 / 16' },
      { type: 'video', src: '/assets/loreal/v08.mp4', poster: '/assets/loreal/v08.jpg', aspect: '9 / 16' },
      { type: 'video', src: '/assets/loreal/v09.mp4', poster: '/assets/loreal/v09.jpg', aspect: '9 / 16' },
      { type: 'video', src: '/assets/loreal/v10.mp4', poster: '/assets/loreal/v10.jpg', aspect: '9 / 16' },
    ],
  },
];

export const aboutText = {
  welcome: 'Welcome',
  heading: "HEY, I'M RASHMI!",
  body: "Photographer. Storyteller. Traveller at heart. I'm here to take you along with me as we chase light, catch lived-in moments, and turn everyday places into stories worth keeping. From street corners to lavender fields \u2014 come wander with me.",
  buttonLabel: 'MY STORY',
};

export const quote =
  'I believe in capturing simple life and helping others do the same.';
